import { Schema, number, string, isodate, array } from 'lib/schema';

const DefaultISODate = () => new Date().toISOString();
const DefaultArray = () => [];

export default class MediaFile extends Schema {
  @string id = { default: null };

  @isodate created = { default: DefaultISODate };

  @isodate modified = { default: DefaultISODate };

  @number bitrate = { default: null };

  @number duration = { default: null };

  @number channelCount = { default: null };

  @number contentLength = { default: null };

  @string episodeId = { default: null };

  @string encoding = { default: null };

  @string mediaUrl = { default: null };

  @number offsetToAudio = { default: null };

  @string peakFileUrl = { default: null };

  @number samplingRate = { default: null };

  @string sourceMediaUrl = { default: null };

  @string s3MediaUrl = { default: null };

  @string s3PeakFileUrl = { default: null };

  @string showId = { default: null };

  @array silenceDetected = { default: DefaultArray };

  getUrlOfEncodedFile() {
    return this.s3MediaUrl;
  }
}
